__turbopack_context__.v({
  "className": "handbookserif_96eb5ce1-module__ppigbG__className",
  "variable": "handbookserif_96eb5ce1-module__ppigbG__variable",
});
